var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-history-list"},[_vm._l((_vm.broadcasts),function(broadcast){return _c('BroadcastHistoryBanner',{key:broadcast.id,attrs:{"broadcast":broadcast}})}),_vm._v(" "),_vm._l(((_vm.loading ? [1, 2, 3] : [])),function(item){return _c('BroadcastHistoryBanner',{key:item,attrs:{"loading":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }